module.exports = __webpack_public_path__ + "static/img/request.6df2a34.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/projects/management/request.jpg
// module id = hnXK
// module chunks = 1